import { render, staticRenderFns } from "./AppPrice.vue?vue&type=template&id=1b56d02e"
import script from "./AppPrice.vue?vue&type=script&lang=js"
export * from "./AppPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports